import { render } from "./whatsapp_templates.vue?vue&type=template&id=498ccefe"
import script from "./whatsapp_templates.vue?vue&type=script&lang=js"
export * from "./whatsapp_templates.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__